var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"room-service"},[_c('i',{class:`rhg-font-icon--${_vm.service.code} sm tooltip-dynamic`,attrs:{"role":"tooltip","tabindex":"0","data-toggle":"tooltip","title":_vm.service.name,"data-original-title":_vm.service.name,"aria-label":_vm.service.code}}),_c('div',{staticClass:"room-service__separator"})])
}
var staticRenderFns = []

export { render, staticRenderFns }